import { Button, Stack, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'

import Timer from '../Components/Timer'


const VerifyGateway = () => {

  const navigate = useNavigate()

  const handleNext = () => {
    navigate('/test-gateway')
  }

  return (
    <>
      <Stack
        alignContent={'center'}
        alignItems={'center'}
        spacing={10}
        direction={'column'}
        margin={3}>
        <Typography variant="h1">
          Verifica Gateway
        </Typography>

        <Typography variant="body1" textAlign={'center'}>
          Vai avanti se hai acceso il Gateway da piu di 5 minuti. Altrimenti clicca sul timer e attendi il tempo necessario.
        </Typography>

        <Timer />

        <Button
          variant="contained"
          fullWidth
          onClick={handleNext}
          disabled={false}>
          Avanti
        </Button>
      </Stack>
    </>
  )
}

export default VerifyGateway
